<template>
  <div id="s-video" class="s-video">
    <div
      style="background:black;height:57.2px;width:100%;  position:fixed;top:0;z-index:1000"
    >
      <img src="../../assets/images/close.png" alt @click="close" />
    </div>
    <div class="s-video-box">
      <!-- <div class="s-video-box-item" v-for="(item,index) in videoList" :key="index"> -->
      <!-- 遮罩  -->
      <!-- <div :class="index!==currentIndex? 'video':''"></div> -->
      <video
        v-if="videoList.tencentVideoId === null"
        class="video-js vjs-default-skin vjs-big-play-centered"
        controls
        autoplay="true"
        :poster="videoList.imageUrl"
      >
        <source :src="videoList.videoUrl" type="video/mp4" />
      </video>
      <iframe
        v-if="videoList.tencentVideoId !== null"
        :src="
          `https://v.qq.com/txp/iframe/player.html?vid=${videoList.tencentVideoId}`
        "
        :poster="videoList.imageUrl"
        allowFullScreen="true"
        autoplay="true"
        width="100%"
      ></iframe>
      <!-- <div id="video_container"></div> -->
      <!-- <div
          :id="'id_test_video'+item.id"
          class="video-js"          
          preload='auto'         
          playsinline
          webkit-playsinline
        ></div>-->
      <!-- 腾讯云视频 -->
      <!-- <video         
          id="id_test_video"
         :autoplay="index === 0"
          class="video-js"
          playsinline
          preload="auto"
          webkit-playsinline         
        ></video> -->
      <!-- 腾讯云视频 -->
      <p class="s-title">{{ videoList.title }}</p>
      <p class="sum">{{ videoList.summary }}</p>
      <!-- </div>   -->
      <!-- <p class="dixian" v-if="ishow">我们是有底线的！</p>
      <p class="dixian" v-else>下拉加载更多</p> -->
    </div>
  </div>
</template>

<script>
// import TcPlayer from 'Tcplayer'
import VConsole from "vconsole";
export default {
  data() {
    return {
      page: 0,
      videoUrl: "",
      imageUrl: "",
      id: this.$route.query.id,
      videoList: {},
      idx: this.$route.query.index,
      isClass: "",
      newArr: [],
      scroll: "",
      currentIndex: 0,
      navID: 5,
      ishow: false,
      newVideo: {},
      obj: {},
      options: {},
      playerList: [],
      currentPlay: {},
      player: {}
    };
  },
  created() {
    // this.videoList = JSON.parse(this.$route.query.videoList);
    this.videoList = JSON.parse(localStorage.getItem("videoList"));
    // this.videoUrl = this.videoList.videoUrl
    // this.imageUrl = this.videoList.imageUrl
    // console.log(this.videoList.videoUrl)
    // this.page = this.$route.query.PageIndex;
    // this.addPlayer(this.videoList);
    // this.videoList.forEach(ele => {
    //   ele.options = {
    //     fileID: ele.fileId,
    //     poster: ele.imageUrl,
    //     appID: '1400242743',
    //     bigPlayButton: false,
    //     poster: "" ,
    //     controls:true,
    //   }
    // });
  },
  watch: {
    // idx: {
    //   handler() {},
    //   immediate: true
    // },
  },
  mounted() {
    // const self = this;
    //监听页面到达底部
    // window.onscroll = function() {
    //   var scrollTop =
    //     document.documentElement.scrollTop || document.body.scrollTop; //变量windowHeight是可视区的高度
    //   var windowHeight =
    //     document.documentElement.clientHeight || document.body.clientHeight; //变量scrollHeight是滚动条的总高度
    //   var scrollHeight =
    //     document.documentElement.scrollHeight || document.body.scrollHeight; //滚动条到底部的条件
    //   var offsetHeight =
    //     document.documentElement.offsetHeight || document.body.offsetHeight //网页可见区域高
    //   if (
    //     Math.ceil(scrollTop + scrollHeight) >= offsetHeight ||
    //     parseInt(scrollTop + scrollHeight) >= offsetHeight
    //   ) {
    //     self.page += 1;
    //     self.getMoreVideo(self.page);
    //   }
    // };
    //监听滚动条位置
    // window.addEventListener("scroll", this.scrollTop);
    // window.addEventListener(
    //   "popstate",
    //   e => {
    //     Object.keys(this.obj).forEach(item => {
    //       this.obj[item].dispose();
    //     });
    //   },
    //   false
    // );
    // if (this.videoList instanceof Array && this.videoList.length > 0) {
    // for (let key = 0; key < this.videoList.length; key++) {
    // console.log(`id_test_video${key}`);
    // let player = new TcPlayer("id_test_video1", this.options);
    // window.setTimeout(() => {
    // let player = new TCPlayer("id_test_video" , {
    //   fileID: '5285890797567872428',
    //   appID: '1400242743',
    // });
    // }, 1000);
    // window.setTimeout(() => {
    // this.videoList.forEach((item,index) => {
    //   let player = new TCPlayer("id_test_video" + item.id, item.options);
    //   this.playerList.push(player)
    //   // console.log(this.playerList)
    //   if(index===0) {
    //     this.currentPlay = player
    //   }
    // });
    // }, 1000);
  },
  methods: {
    // getMoreVideo(val) {
    //   if (this.ishow) return;
    //   this.axios
    //     .get("/api/consume/Information/PageList", {
    //       params: {
    //         page: val,
    //         rows: 4,
    //         Type: 5,
    //         videoGroup: this.id
    //       }
    //     })
    //     .then(res => {
    //       for (var i = 0; i < res.data.results.length; i++) {
    //         this.videoList.push(res.data.results[i]);
    //       }
    //       // this.addPlayer(res.data.results);
    //       // this.ishow = res.data.results.length === 0;
    //     });
    // },
    // addPlayer(arr) {
    //     arr.forEach(i => {
    //     i.options = {
    //     fileID: i.fileId,
    //     poster: i.imageUrl,
    //     appID: '1400242743',
    //     bigPlayButton: false,
    //     poster: "" ,
    //     controls:true,
    //   }
    // });
    //   this.$nextTick(() => {
    //     arr.forEach(item => {
    //     let player = new TCPlayer("id_test_video" + item.id, item.options);
    //     this.playerList.push(player)
    //       this.obj[item.id] = this.$video("id_test_video" + item.id, {controls: true});
    //     });
    //   });
    // },

    close() {
      // Object.keys(this.obj).forEach(item => {
      //   this.obj[0].dispose();
      // });
      // var videoElement = document.getElementsByTagName('video')
      //     videoElement.pause();
      //     videoElement.removeAttribute('src'); // empty source
      //     videoElement.load();
      // document.getElementsByTagName('video').setAttribute('src','')
      document.getElementsByTagName("video").videoContext = null;
      // this.$router.push("/videoList.html");
      this.$router.history.go(-1);
    }

    // scrollTop() {
    //   this.scroll =
    //     document.documentElement.scrollTop || document.body.scrollTop;
    //   this.currentIndex = Math.round(
    //     this.scroll /
    //       document.getElementsByClassName("s-video-box-item")[2].offsetHeight
    //   );
    //   for(let i=0; i<this.playerList.length;i++) {
    //         this.playerList[i].pause()
    //         this.playerList[this.currentIndex].play()
    //   }
    // },
  }
};
</script>

<style scoped>
#s-video .video {
  z-index: 2000;
  overflow: hidden;
  clear: both;
  background: rgba(0, 0, 0, 0.6);
  height: 100%;
  width: 100%;
  position: absolute;
  left: 0;
  top: 0px;
  opacity: 0.5;
}

#s-video.s-video {
  /* padding-bottom: 40px; */
  width: 100%;
  height: 100%;
  z-index: 1;
  background: black;
  /* padding-top: 85px; */
  position: fixed;
}
#s-video.s-video img {
  margin: 34.5px 50px;
  width: 36px;
  height: 35px;
}
#s-video.s-video .s-title {
  font-size: 26px;
  color: #e0e0e0;
  margin-left: 30px;
  margin-top: 31px;
}
#s-video.s-video .sum {
  font-size: 22px;
  color: #7f889d;
  margin-top: 15px;
  margin-left: 30px;
}
#s-video .dixian {
  color: white;
  font-size: 22px;
  text-align: center;
  padding-bottom: 350px;
  margin-top: 100px;
}
#s-video .s-video-box {
  background: black;
  /* padding-bottom: 180px; */
  position: absolute;
  left: 0;
  top: 20%;
  width: 100%;
}
#s-video .s-video-box-item {
  box-sizing: border-box;
  z-index: 100;
  padding-bottom: 31px;
  position: relative;
}
#s-video .video-js {
  margin: 0 auto;
  width: 100%;
  height: auto;
}
#s-video video {
  outline: none;
}
#s-video .video-js .vjs-time-control {
  line-height: 1.5em;
}
#s-video .video-js .vjs-control-bar {
  height: 1.5em;
}
#s-video .video-js .vjs-big-play-button {
  top: 1.8em;
  left: 3.5em;
}
</style>



// WEBPACK FOOTER //
// src/components/video/S-video.vue